export default __webpack_public_path__ + "static/media/icons-system-chevron-right-disabled.b9ebb661.svg";